import type { CSSProperties, MouseEvent, ReactNode } from 'react';
import styles from './Badge.module.css';

export type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClick?: (e: MouseEvent<HTMLSpanElement>) => void;
}

export default function Badge({
  variant = 'neutral',
  children,
  className = '',
  style,
  onClick,
}: BadgeProps) {
  return (
    <span
      className={`${styles.badge} ${styles[variant]} ${className}`.trim()}
      style={style}
      onClick={onClick}
    >
      {children}
    </span>
  );
}
